import React from 'react';
import { Form } from 'react-bootstrap';

/**Function component which handles displaying different
 *  items in the node type list */
export const NodeTypes = (props) => {
    return !props.edit ? < Form.Group >
        <Form.Label>Node Type</Form.Label>
        <Form.Control
            as="select"
            onChange={props.selectChanger}
            value={props.type ? props.type : undefined}
            disabled={props.readOnly}

        >
            {props.rootParent ? (
                <option value="hub">Hub</option>
            ) : null}

            {props.siteShow ? <option value="site">Site</option> : null}
            <option value="docLib">Document Library</option>
            <option value="page">Page</option>

        </Form.Control>
    </Form.Group> : null;
};


// WEBPACK FOOTER //
// ./src/components/tree/node/NodeTypes.js